import React from 'react';
import PropTypes from 'prop-types';
import styles from './Year.module.scss';

const Year = ({children, disabled, shy, selected, clickHandler}) => {

    const classes = [styles.year];
    if (shy || disabled) classes.push(styles.shy);
    if (disabled) classes.push(styles.disabled);
    if (selected) classes.push(styles.selected);

    const monthClickHandler = disabled ? () => null : clickHandler;

    return (
        <div className={styles.container}>
            <div className={styles.dummy}/>
            <div className={classes.join(' ')} onClick={monthClickHandler}>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>

    );
};

Year.propTypes = {
    children: PropTypes.any,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    shy: PropTypes.bool,
    clickHandler: PropTypes.func,
};

Year.defaultProps = {
    children: null,
    disabled: false,
    selected: false,
    shy: false,
    clickHandler: () => null,
};

export default Year;
